import "../../FhCard.css";
import { computed, openBlock, createBlock, resolveDynamicComponent, normalizeClass, withCtx, renderSlot, createCommentVNode } from "vue";
import { CARD_TAG_ENUMS, CARD_SIZE_ENUMS } from "./constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhCard",
  props: {
    tag: {
      type: String,
      default: CARD_TAG_ENUMS.DIV,
      validator: (value) => Object.values(CARD_TAG_ENUMS).includes(value)
    },
    elevated: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: CARD_SIZE_ENUMS.MD,
      validator: (value) => Object.values(CARD_SIZE_ENUMS).includes(value)
    },
    filled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const computedClasses = computed(() => {
      return [
        "fh-card",
        props.elevated && "fh-card--elevated",
        `fh-card--${props.size}`,
        props.filled && "fh-card--filled"
      ];
    });
    return (_ctx, _cache) => {
      return _ctx.$slots.default ? (openBlock(), createBlock(resolveDynamicComponent(props.tag), {
        key: 0,
        class: normalizeClass(computedClasses.value)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["class"])) : createCommentVNode("", true);
    };
  }
};
const FhCard = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-19e9fd29"]]);
export {
  FhCard as default
};
//# sourceMappingURL=FhCard.mjs.map
